// Types
export type UpgradeReason =
  | 'messageLimit'
  | 'searchLimit'
  | 'wordCountLimit'
  | 'importLimit'
  | 'pageLimit'
  | 'sizeLimit'
  | 'recordingLimit'
  | 'modelChange'
  | 'maxLengthChange'
  | 'teamsFeature'
  | 'strategyFeature'
  | 'dailyPageLimit'
  | 'generic'
  | null;

export type UserPlan = 'Free' | 'Pro' | 'Team';

type Feature = {
  text: string;
};

// Feature configurations
export const featuresByPlan: Record<UserPlan, Feature[]> = {
  Free: [
    { text: 'Unlimited messages' },
    { text: 'Unlimited text generations' },
    { text: 'Access to the best AI models' },
    { text: 'Improved answers and higher accuracy search' },
    { text: 'Up to 300MB or 10K pages per upload' },
    { text: 'Priority customer support' },
    { text: 'Cancel anytime' },
  ],
  Pro: [
    { text: 'Unlimited AI words' },
    { text: 'Unlimited uploads and recordings' },
    {
      text: 'Access to premium models built on Claude 4 Sonnet, GPT 4.1, and Gemini 2.5 Pro',
    },
    { text: '10,000 pages or 300MB per upload' },
  ],
  Team: [
    { text: 'Shared notes, documents and chats' },
    { text: 'Add team members to each chat' },
    { text: 'Admin panel for access management' },
    { text: 'Dedicated account manager' },
    { text: 'Early access to new features' },
  ],
};

// const _subline = () => {
// if (inactiveMessage) {
//   return 'Your most recent payment failed. Please update your billing details to continue.';
// }
// if (upgradeReason === 'sizeLimit' && userPlan !== 'Free') {
//   return 'Our support team will be happy to assist you with importing larger documents.';
// }
// return match(upgradeReason)
//   .with(
//     'teamsFeature',
//     () => 'Join 100s of teams supercharging their research with Anara.',
//   )
//   .with(
//     'strategyFeature',
//     () =>
//       'Upgrade to import scanned, poorly formatted or handwritten documents. You’ll also get:',
//   )
//   .otherwise(
//     () =>
//       'Invest in your success with a paid plan. Unlimited access, cancel anytime.',
//   );
// };
